import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["progressCount"]
  static values = { status: String, pollUrl: String }

  connect() {
    this.element.showModal()

    if (this.statusValue === "processing") {
      this.timer = setInterval(() => this.poll(), 3000)
    }
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  async poll() {
    try {
      const response = await fetch(this.pollUrlValue)
      const data = await response.json()

      if (data.status !== "processing") {
        clearInterval(this.timer)
        if (data.status === "completed" && data.talk_script_id) {
          const currentPath = window.location.pathname
          const basePath = currentPath.replace(/\/talk_script_imports\/.*/, "/talk_scripts/")
          window.location.href = basePath + data.talk_script_id
        } else {
          const url = new URL(window.location.href)
          url.searchParams.set("from_import", "1")
          window.location.href = url.toString()
        }
        return
      }

      if (this.hasProgressCountTarget) {
        this.progressCountTarget.textContent = "処理中です…"
      }
    } catch {
      // ネットワークエラー時は次回ポーリングで再試行
    }
  }

  close() {
    this.element.close()
  }
}
